export default __webpack_public_path__ + "static/media/Artboard 11.b41543b5.png";